<template>
    <div class="search-engine">
        <div class="search-engine__block">
            <input
                type="text"
                name="q"

                class="search-engine__input"
                @click="handleOpen($event)"
                @input="handlerInput($event)"
                :placeholder="getPlaceholder()"
            >
            <transition name="fade">
                <div v-if="Object.keys(result).length > 0 && openItems" class="vue-search__result">
                    search...
                </div>
            </transition>
        </div>
        <svg width="20px" height="20px" class="search-engine__icon">
            <use xlink:href="#svg-magnifying"></use>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'search-engine',
    selector: '.search-engine',
    props: {
        params: {
            type: Object,
            default: () => ({
                "ajax": {
                    "url": "/ajax/",
                    "data": {
                        "action": "search",
                        "ajax": "y",
                        "lang": "ru",
                        "q": "safd"
                    },
                    "searchName": "q",
                    "delay": 100
                },
                "placeholder": "Поиск"
            })
        }
    },
    data() {
        const obg = {
            result: {},
            value: '',
            timeout: '',
            openItems: false,
        }
        return obg;
    },
    methods: {
        handlerInput(e) {
            const params = this.params;
            let delay = 1000;
            if (params && params.ajax && params.ajax.searchName) {
                delay = params.ajax.searchName;
            }
            this.value = e.target.value;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.gerSearchElements.bind(this), delay);
        },
        gerSearchElements: async function () {
            try {
                const params = this.params;

                if (params && params.ajax && params.ajax.url && params.ajax.searchName && this.value !== '') {
                    let data = params.ajax.data;
                    data[params.ajax.searchName] = this.value;
                    const response = await axios.get(params.ajax.url, {params: data});
                    this.result = response.data;
                    this.openItems = true;
                } else {
                    this.result = {}
                }
            } catch (err) {
                console.error(err);
            }
        },
        handleOpen() {
            if (this.value === '') this.result = {};
            this.openItems = !this.openItems;

            if (this.openItems) {
                document.addEventListener('click', this.handlerAnotherClick);
            } else {
                document.removeEventListener('click', this.handlerAnotherClick);
            }
        },
        handlerAnotherClick({target}) {
            const parent = target.closest('.vue-search__block');
            if (!parent) {
                this.openItems = false;
                document.removeEventListener('click', this.handlerAnotherClick);
            }
        },
        getValue() {
            if (this.$attrs.value != undefined) {
                return this.$attrs.value;
            } else {
                return "";
            }

        },
        getPlaceholder() {
            if (this.$attrs.result.placeholder != undefined) {
                return this.$attrs.result.placeholder;
            } else {
                return "";
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.search-engine {
    display: inline-flex;
    position: relative;
    flex-grow: 1;
    max-width: 520px;
    width: 100%;

    &__icon {
        position: absolute;
        width: 22px;
        height: 23px;
        top: 50%;
        transform: translateY(-50%);
        right: 13px;
        pointer-events: none;
        z-index: 10;
    }

    &__input {
        height: 56px;
        padding: 0px 16px;
        width: 100%;
        border: 1px solid #DFDFDF;
        font-weight: 500;
        font-size: rem(16);
        line-height: 140%;
        color: #757575;
        cursor: text;
        &::placeholder {
            color: #757575;
            font-size: rem(16);
        }


    }

    &__result {
        position: absolute;
        width: 100%;
        background-color: #fff;
        z-index: 2;
        top: calc(100% + 1px);
        box-shadow: 0 3px 40px rgba(181, 177, 167, 0.16);
    }

    &__block {
        width: 100%;
    }
}
</style>